import { makeStyles } from '@material-ui/styles'
import tinycolor from "tinycolor2";

export default makeStyles(theme => ({
    contentDiv: {
      width: "100%"
    },
    notificationCallButton: {
      color: "white",
      marginBottom: theme.spacing(1),
      textTransform: "none"
    },
    notificationItem: {
      marginTop: theme.spacing(2)
    },
    notificationCloseButton: {
      position: "absolute",
      right: theme.spacing(2)
    },
    toastsContainer: {
      width: "auto",
      marginTop: theme.spacing(6),
      right: 0
    },
    progress: {
      visibility: "hidden"
    },
    notification: {
      display: "flex",
      alignItems: "center",
      background: "transparent",
      boxShadow: "none",
      overflow: "visible"
    },
    searchIcon: {
      color: "rgba(0, 0, 0, 0.23)"
    },

    notificationComponent: {
      paddingRight: theme.spacing(4),
    },

    savebuttonText: {
      color: 'black',
      "&:hover, &:focus": {
        backgroundColor: theme.lightgrey,
      }
    },
    accountImageDiv: {
      width: '50px',
      height: '50px',
    },
    accountImage: {
      width: '100%',
      height: '100%',
      borderRadius: '50px',
      objectFit: 'contain',
    },
    imageNameColumn: {
      display: 'flex',
      alignItems: 'center'
    },
    overflowx: {
      overflowX: 'scroll'
    },

}))
